const numberFormat = new Intl.NumberFormat();

export function formatMetric(value: null | number | undefined): string {
  return value === null || value === undefined
    ? "—"
    : numberFormat.format(value);
}
